<script setup>
import { computed } from 'vue';
import logoSenKo from '@/assets/images/result/logo_sen_ko.png';
import symbol from '@/assets/images/result/symbol_sen.png';

const props = defineProps({
  pageIndex: {
    type: Number,
    default: 0
  },
  reportType: {
    type: String,
    default: 'student' // student, teacher, principal
  },
  examDate: {
    type: String,
    default: '2026'
  },
  subHeaderText: {
    type: String,
    default: ''
  }
});

const isFirstPage = computed(() => props.pageIndex === 0);
</script>

<template>
  <header class="result-header">
    <div class="header-content">
      <!-- 첫 페이지 헤더 -->
      <template v-if="isFirstPage">
        <img :src="logoSenKo" alt="한글 로고" class="korean-logo">
        <p class="date">{{ examDate }}</p>
      </template>
      
      <!-- 나머지 페이지 헤더 -->
      <template v-else>
        <div class="logo-wrap">
          <div class="symbol-wrap">
            <img :src="symbol" alt="심볼">
          </div>
          <div class="line"></div>
          <div class="english-text">
            <p class="shippori-mincho-extrabold">
              SEOUL METROPOLITAN OFFICE<br> 
              OF EDUCATION
            </p>
          </div>
        </div>
        <div class="text-wrap text-right">
          <p style="font-weight: 500;">서울 학생 문해력·수리력 진단검사(S-PLAN)</p>
          <p style="font-size:28px; font-weight: 600;">{{ subHeaderText }}</p>
        </div>
      </template>
    </div>
  </header>
</template>

<style lang="scss" scoped>
.result-header {
  width: 100%;
  padding: 15px 50px;
  background: white;
  flex-shrink: 0;
  
  .header-content {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    
    .korean-logo {
      height: auto;
      max-height: 50px;
      width: auto;
    }
    
    .date {
      font-size: 18px;
      color: #666;
    }
    
    .logo-wrap {
      display: flex;
      align-items: center;
      gap: 15px;
      
      .symbol-wrap {
        flex-shrink: 0;
        
        img {
          width: auto;
        }
      }
      
      .line {
        width: 2px;
        height: 40px;
        background: #333;
        flex-shrink: 0;
      }
      
      .english-text {
        flex-shrink: 0;
        min-width: 0;
        
        .shippori-mincho-extrabold {
          font-family: 'Shippori Mincho', serif;
          font-weight: 800;
          font-size: 13px;
          line-height: 1.3;
          white-space: nowrap;
          letter-spacing: -0.2px;
        }
      }
    }
    
    .text-wrap {
      text-align: right;
      
      p:first-child {
        margin-bottom: 8px;
        color: #666;
      }
    }
  }
}

@media print {
  .result-header {
    page-break-inside: avoid;
  }
}
</style>